export default {
  'NOT FOUND': 'NOT FOUND',
  'You just hit a route that doesnt exist the sadness':
    "You just hit a route that doesn't exist.",
};
